// Scheduler feature entry — plan the feed, let it post itself.
import { CalendarClock } from "lucide-react";
import type { FeatureModule } from "../registry";

const scheduler: FeatureModule = {
  id: "scheduler",
  nav: [{ to: "/scheduler", label: "Scheduler", icon: CalendarClock, group: "content", order: 10 }],
  routes: [
    {
      path: "/scheduler",
      lazy: async () => ({ Component: (await import("./SchedulerPage")).SchedulerPage }),
    },
  ],
};

export default scheduler;
